// Article page (parts/Blog SEO "Article"): "In this article" from the body's h2s, and Share. Without JavaScript both stay hidden.

// A URL fragment for a heading: lower case, letters and digits joined by dashes, made unique against ids already taken.
export function slug(text, taken = new Set()) {
  const base = String(text ?? '').toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[^\p{L}\p{M}\p{N}]+/gu, '-').replace(/^-+|-+$/g, '') || 'section';
  let id = base;
  for (let n = 2; taken.has(id); n += 1) id = `${base}-${n}`;
  taken.add(id);
  return id;
}

// The contents list: one entry per heading with text, keeping an id the heading already has.
export function tocItems(headings, taken = new Set()) {
  return headings
    .map(heading => ({ heading, text: String(heading.textContent ?? '').replace(/\s+/g, ' ').trim() }))
    .filter(item => item.text)
    .map(({ heading, text }) => ({ heading, text, id: heading.id || slug(`toc-${text}`, taken) }));
}

// Click-to-play video (the blog media contract): a YouTube id is 6 to 15 letters, digits, dashes or underscores.
export const isVideoId = value => /^[A-Za-z0-9_-]{6,15}$/.test(String(value ?? ''));

export const embedUrl = id => `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`;

// The player that replaces the poster link in the same 16:9 box, or null when the id is not valid (the link then opens YouTube).
export function playerFor(doc, id, title) {
  if (!isVideoId(id)) return null;
  const frame = doc.createElement('iframe');
  frame.src = embedUrl(id);
  frame.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
  frame.setAttribute('allowfullscreen', '');
  frame.setAttribute('loading', 'lazy');
  frame.setAttribute('title', title || 'Video player');
  frame.style.border = '0';
  frame.style.aspectRatio = '16 / 9';
  frame.style.width = '100%';
  return frame;
}

if (typeof document !== 'undefined') {
  const toc = document.querySelector('[data-ns-toc]');
  const body = document.querySelector('[data-ns-article-body]');
  if (toc && body) {
    const taken = new Set([...document.querySelectorAll('[id]')].map(node => node.id));
    const items = tocItems([...body.querySelectorAll('h2')], taken);
    if (items.length >= 2) {
      const list = toc.querySelector('[data-ns-toc-list]');
      for (const { heading, text, id } of items) {
        heading.id = id;
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${id}`;
        link.textContent = text;
        item.append(link);
        list.append(item);
      }
      toc.hidden = false;
    }
  }
  const share = document.querySelector('[data-ns-share]');
  if (share && (navigator.share || navigator.clipboard)) {
    share.hidden = false;
    share.addEventListener('click', async () => {
      const data = { title: document.title, url: window.location.href.split('#')[0] };
      try {
        if (navigator.share) await navigator.share(data);
        else {
          await navigator.clipboard.writeText(data.url);
          share.textContent = share.dataset.copied;
        }
      } catch { /* the shopper closed the share sheet */ }
    });
  }

  document.addEventListener('click', event => {
    const link = event.target instanceof Element ? event.target.closest('.ns-vid[data-ns-vid] .ns-vid__play') : null;
    if (!link) return;
    const box = link.closest('.ns-vid');
    const frame = playerFor(document, box.dataset.nsVid, box.dataset.nsVidTitle);
    if (!frame) return;
    event.preventDefault();
    link.replaceWith(frame);
    frame.focus();
  });
}
